import { render, staticRenderFns } from "./editName.vue?vue&type=template&id=40c6acfa"
import script from "./editName.vue?vue&type=script&lang=js"
export * from "./editName.vue?vue&type=script&lang=js"
import style0 from "./editName.vue?vue&type=style&index=0&id=40c6acfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports